export default class ShyListener {
  constructor() {
    this.shyOffset = 250;
    this.shyClass = 'js-shy';
    this.transparentHeaderClass = 'js-transparent-header';
    this.lastUp = window.pageYOffset;

    window.addEventListener("scroll", () =>
      this.scrollListener(window.pageYOffset)
    );
    document.addEventListener("DOMContentLoaded", () =>
      setTimeout(() =>
        this.scrollListener(window.pageYOffset)
      , 500)
    );

  }

  scrollListener(top) {
    if (
      top < this.lastUp ||
      document.body.classList.contains("js-bab-open") ||
      document.querySelector(".site-header")?.classList.contains("js-menu-open")
    ) {
      this.showShy(top);
    } else if (top > this.shyOffset + this.lastUp) {
      this.hideShy(top);
    }

    // this.transparentListener(top);
  }

  transparentListener(top) {
    const heroRegion = document.querySelector(".site-hero");
    const heroExists = !!heroRegion;
    const headerBottom =
      top + document.querySelector(".site-header")?.offsetHeight;
    const headerAboveHero =
      heroExists &&
      headerBottom < document.querySelector(".site-hero")?.offsetHeight;

    document.body.classList[headerAboveHero ? "add" : "remove"](
      this.transparentHeaderClass
    );
  }

  hideShy(top = window.pageYOffset) {
    document.body.classList.add(this.shyClass);
    this.lastUp = top;
  }

  showShy(top = window.pageYOffset) {
    document.body.classList.remove(this.shyClass);
    this.lastUp = top;
  }
};
